import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';

import EventViews from '../../../../../containers/dashboards/cards/builder/event/EventViews';
import EventFormula from '../../../../../containers/dashboards/cards/builder/event/EventFormula';
import EventLegend from '../../../../../containers/dashboards/cards/builder/event/EventLegend';
import EventsItem from '../../../../../containers/dashboards/cards/builder/event/Item';
import EventsGroupByFieldOption from '../../../../../containers/dashboards/cards/builder/event/GroupByFieldOption';
import EventsSplitByFieldOption from '../../../../../containers/dashboards/cards/builder/event/SplitByFieldOption';
import EventsAggregationFieldOption from '../../../../../containers/dashboards/cards/builder/event/AggregationFieldOption';
import EventItemFilter from '../../../../../containers/dashboards/cards/builder/event/EventItemFilter';
import AggregationContainer from '../../../../../containers/dashboards/cards/builder/event/AggregationContainer';

const StyledEventsItemOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const StyledEventsViewContainer = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
  overflow: hidden;

  .sidelist-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    width: 100%;

    .item-container {
      overflow-y: auto;
      padding-right: 0;
      flex: 1;
      position: relative;
    }

    .views-formula-container {
      margin: 10px;
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
    }
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

const buildItem = (eventId, unitId, showNotValidFields) => (
  <EventsItem
    key={eventId.toString()}
    eventId={eventId}
    unitId={unitId}
    showNotValidFields={showNotValidFields}
  >
    <StyledEventsItemOptionsContainer>
      <div>
        <EventsGroupByFieldOption
          showNotValidFields={showNotValidFields}
          id={eventId}
          unitId={unitId}
        />
        <EventsSplitByFieldOption id={eventId} unitId={unitId} />
        <AggregationContainer id={eventId} unitId={unitId} />
        <EventsAggregationFieldOption
          showNotValidFields={showNotValidFields}
          id={eventId}
          unitId={unitId}
        />
      </div>
      <div>
        <EventItemFilter id={eventId} unitId={unitId} />
      </div>
    </StyledEventsItemOptionsContainer>
  </EventsItem>
);

const EventsView = (props) => {
  const { unit, onEventAdd, eventIds, showNotValidFields } = props;

  return (
    <StyledEventsViewContainer>
      <div className="sidelist-container">
        <div className="item-container">
          {eventIds.map((eventId) => {
            return buildItem(eventId, unit.id, showNotValidFields);
          })}
          <div className="views-formula-container">
            <EventViews {...props} unitId={unit.id} />
            <div>
              <EventFormula {...props} />
              <EventLegend unit={unit} />
            </div>
          </div>
        </div>
        <div>
          <StyledButton onClick={() => onEventAdd(unit.id)} type="primary">
            Add event
          </StyledButton>
        </div>
      </div>
    </StyledEventsViewContainer>
  );
};

export default EventsView;
